<template>
    <div class="container mt-3 flex-fill">
        <div class="row justify-content-center">
            <p class="text-center">Inscrivez-vous et recevez notre <br> newsletter, pour profiter d'une <strong>remise de <br> 10%*</strong> sur votre premier panier.</p>
        </div>

        <div class="row justify-content-center mt-3">
            <p class="text-center">Pour commencer, renseignez votre <br> adresse e-mail ci-dessous :</p>
        </div>

        <div class="row justify-content-center">
            <form class="col-md-6 col-12" @submit.prevent="submitEmail">
                <div class="form-group mb-5 mt-3">
                    <input v-model="email" id="email" class="input-braderie form-control w-100 mx-auto" type="email" name="email" placeholder="Adresse e-mail*" required />
                </div>

                <button class="button-braderie w-75 d-block mx-auto" type="submit" :disabled="isLoading">
                    <span v-if="!isLoading">Suivant</span>
                    <span v-else>Veuillez patienter...</span>
                </button>
            </form>
            
        </div>
        <div class="row justify-content-center mt-3">
            <p v-if="apiErrorMessage" class="text-danger text-center">{{ apiErrorMessage }}</p>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'StepEmail',
        props: {
            apiErrorMessage: String
        },
        data() {
            return {
                email: '',
                isLoading: false
            }
        },
        watch: {
            apiErrorMessage(newVal) {
                if (newVal) {
                    this.isLoading = false;
                }
            }
        },
        methods: {
            submitEmail() {
                if (this.isLoading) return;

                this.isLoading = true;

                this.$emit('next', { email: this.email });
            }
        }
    }
</script>